import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LeadPartnerCard from './components/LeadPartnerCard';
import LeadPartnerApplyModal from './components/LeadPartnerApplyModal';
import RateQuoteDetailPanel from './components/RateQuoteDetailPanel';
import { leadPartnersHero, partners } from './data/rateQuoteStaticContent';

function LeadPartnersPage({ setLocalLoader }) {
  const [view, setView] = useState('list');
  const [applyModalOpen, setApplyModalOpen] = useState(false);

  useEffect(() => {
    setLocalLoader(false);
  }, [setLocalLoader]);

  const rq = partners.rateQuote;
  // const other = partners.other;

  return (
    <div className='w-full p-4 bg-white'>
      <header className='text-center mb-6'>
        <h1 className='md:text-4xl text-3xl font-bold text-black leading-none mb-2'>
          {leadPartnersHero.pageTitle}
        </h1>
        <p className='text-grey text-[length:--font-size-body] max-w-xl mx-auto'>
          {leadPartnersHero.instruction}
        </p>
      </header>

      <div data-tour='leads-partners-cards' className='flex flex-wrap gap-6 justify-center mb-10'>
        <LeadPartnerCard
          title={rq.label}
          selected={view === 'rateQuote'}
          onClick={() => setView('rateQuote')}
        />
        {/* <LeadPartnerCard
          title={other.label}
          subtitle={other.comingSoon}
          disabled
        /> */}
      </div>

      {view === 'rateQuote' ? (
        <RateQuoteDetailPanel
          onApplyNow={() => setApplyModalOpen(true)}
          onBackToList={() => setView('list')}
        />
      ) : null}

      <LeadPartnerApplyModal
        active={applyModalOpen}
        closeModal={() => setApplyModalOpen(false)}
        leadPartnerName={rq.zohoLeadPartnerName}
      />
    </div>
  );
}

LeadPartnersPage.propTypes = {
  setLocalLoader: PropTypes.func.isRequired
};

export default LeadPartnersPage;
